export default "/_next/static/assets/tsa-pre@2x_f51b30940955bc3ff767662fdde4fe9f.png";